import { Layers } from 'lucide-react';
import { useEntityScope } from '../hooks/useEntityScope.js';

/**
 * Wraps a page that only makes sense for a single entity. When the session is
 * in group scope, renders an info card prompting the user to pick one.
 *
 * Usage : <RequiresSingleEntity>{<Page />}</RequiresSingleEntity>
 */
export default function RequiresSingleEntity({ children, label }) {
  const { isGroup, isLoading } = useEntityScope();

  if (isLoading) return children;
  if (!isGroup) return children;

  return (
    <div className="max-w-xl mx-auto mt-12 rounded-xl border border-slate-200 bg-white px-6 py-8 text-center shadow-sm">
      <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-slate-100">
        <Layers size={18} className="text-slate-500" aria-hidden />
      </div>
      <h2 className="text-base font-semibold text-slate-900 mb-1">
        {label ?? 'Cette page nécessite une société'}
      </h2>
      <p className="text-sm text-slate-500">
        Sélectionne une société dans le sélecteur pour afficher cette vue. La vue groupe
        n'est disponible que sur l'accueil, le cash-flow, les stats et la page à payer.
      </p>
    </div>
  );
}
